export default "__VITE_ASSET__C_cl5prD__"